import { Reveal } from "@/components/Reveal";

const SubpageLayout = ({ overline, title, art, children, testId }) => (
  <main data-testid={testId} className="px-6 pb-28 pt-36 lg:pb-40 lg:pt-48">
    <div className="mx-auto max-w-2xl">
      <Reveal>
        <div className="flex items-start justify-between gap-10">
          <div>
            {overline && (
              <p className="text-xs font-medium tracking-[0.25em] text-[#B46A45]">{overline}</p>
            )}
            <h1 className="mt-4 font-serif text-4xl leading-tight text-[#3F5A47] sm:text-5xl">
              {title}
            </h1>
            <div className="mt-9 h-px w-16 bg-[#3F5A47]" />
          </div>
          {art && (
            <img src={art} alt="" className="mt-1 h-20 w-auto shrink-0 sm:h-28" />
          )}
        </div>
      </Reveal>
      <Reveal delay={0.15} className="mt-14">
        {children}
      </Reveal>
    </div>
  </main>
);

export default SubpageLayout;
